module.exports = __webpack_public_path__ + "img/606.e8c7573c.png";